export const productData = [
  {
    img: "/productImgs/Arches/Arche1b.jpg",
    category: "Archies",
    name: "Arches",
    prize: "Rs. 15000/-",
    id: 1,
  },
  {
    img: "/productImgs/Arches/Arche2.jpeg",
    category: "Archies",
    name: "Arches",
    prize: "Rs. 15000/-",
    id: 2,
  },
  {
    img: "/productImgs/Arches/Arche3.jpeg",
    category: "Archies",
    name: "Arches",
    prize: "Rs. 15000/-",
    id: 3,
  },
  {
    img: "/productImgs/Arches/Arche4.jpeg",
    category: "Archies",
    name: "Arches",
    prize: "Rs. 15000/-",
    id: 4,
  },
  {
    img: "/productImgs/Arches/Arche5.jpeg",
    category: "Archies",
    name: "Arches",
    prize: "Rs. 15000/-",
    id: 5,
  },

  {
    img: "/productImgs/Costumes/Costumes1.jpg",
    category: "Costumes",
    name: "Costumes",
    prize: "Rs. 25000/-",
    id: 6,
  },
  {
    img: "/productImgs/Costumes/Costumes2.jpg",
    category: "Costumes",
    name: "Costumes",
    prize: "Rs. 22000/-",
    id: 7,
  },
  {
    img: "/productImgs/Costumes/Costumes3.jpg",
    category: "Costumes",
    name: "Costumes",
    prize: "Rs. 23000/-",
    id: 8,
  },
  {
    img: "/productImgs/Costumes/Costumes4.jpg",
    category: "Costumes",
    name: "Costumes",
    prize: "Rs. 24000/-",
    id: 9,
  },
  {
    img: "/productImgs/Costumes/Costumes5.jpg",
    category: "Costumes",
    name: "Costumes",
    prize: "Rs. 24000/-",
    id: 10,
  },
  {
    img: "/productImgs/Costumes/Costumes6.jpg",
    category: "Costumes",
    name: "Costumes",
    prize: "Rs. 24000/-",
    id: 11,
  },
  {
    img: "/productImgs/Costumes/Costumes7.jpg",
    category: "Costumes",
    name: "Costumes",
    prize: "Rs. 24000/-",
    id: 12,
  },
  {
    img: "/productImgs/Costumes/Costumes8.jpg",
    category: "Costumes",
    name: "Costumes",
    prize: "Rs. 24000/-",
    id: 13,
  },
  {
    img: "/productImgs/Danglers/Danglers1.jpg",
    category: "Danglers",
    name: "Danglers",
    prize: "Rs. 34000/-",
    id: 14,
  },
  {
    img: "/productImgs/InflatableBounce/InflatableBounce1.jpg",
    category: "InflatableBounce",
    name: "Inflatable Bounce",
    prize: "Rs. 38000/-",
    id: 15,
  },
  {
    img: "/productImgs/Tent/Tent11.jpg",
    category: "Tent",
    name: "Tent",
    prize: "Rs. 36000/-",
    id: 16,
  },
  {
    img: "/productImgs/Tent/Tent1.jpg",
    category: "Tent",
    name: "Tent",
    prize: "Rs. 36000/-",
    id: 17,
  },
  {
    img: "/productImgs/Tent/Tent2.jpg",
    category: "Tent",
    name: "Tent",
    prize: "Rs. 30000/-",
    id: 18,
  },
  {
    img: "/productImgs/Tent/Tent3.jpg",
    category: "Tent",
    name: "Tent",
    prize: "Rs. 31000/-",
    id: 19,
  },
  {
    img: "/productImgs/Tent/Tent4.jpg",
    category: "Tent",
    name: "Tent",
    prize: "Rs. 36000/-",
    id: 20,
  },
  {
    img: "/productImgs/Tent/Tent5.jpg",
    category: "Tent",
    name: "Tent",
    prize: "Rs. 30000/-",
    id: 21,
  },
  {
    img: "/productImgs/Tent/Tent6.jpg",
    category: "Tent",
    name: "Tent",
    prize: "Rs. 31000/-",
    id: 22,
  },
  {
    img: "/productImgs/Tent/Tent7.jpg",
    category: "Tent",
    name: "Tent",
    prize: "Rs. 30000/-",
    id: 23,
  },
  {
    img: "/productImgs/Tent/Tent8.jpg",
    category: "Tent",
    name: "Tent",
    prize: "Rs. 37000/-",
    id: 24,
  },
  {
    img: "/productImgs/Tent/Tent9.jpeg",
    category: "Tent",
    name: "Tent",
    prize: "Rs. 30000/-",
    id: 25,
  },
  {
    img: "/productImgs/Tent/Tent10.jpg",
    category: "Tent",
    name: "Tent",
    prize: "Rs. 38000/-",
    id: 26,
  },
  {
    img: "/productImgs/Water_Roller/water_roller1.jpeg",
    category: "Water Roller",
    name: "Water Roller",
    prize: "Rs. 30000/-",
    id: 27,
  },
  {
    img: "/productImgs/Water_Roller/water_roller2.jpeg",
    category: "Water Roller",
    name: "Water Roller",
    prize: "Rs. 32000/-",
    id: 28,
  },
  {
    img: "/productImgs/Water_Roller/water_roller3.jpeg",
    category: "Water Roller",
    name: "Water Roller",
    prize: "Rs. 34000/-",
    id: 29,
  },
  {
    img: "/productImgs/Water_Roller/water_roller4.jpeg",
    category: "Water Roller",
    name: "Water Roller",
    prize: "Rs. 30000/-",
    id: 30,
  },
  {
    img: "/productImgs/Water_Roller/water_roller5.jpeg",
    category: "Water Roller",
    name: "Water Roller",
    prize: "Rs. 32000/-",
    id: 31,
  },

  {
    img: "/productImgs/Balloons/balloon1.jpg",
    category: "Balloons",
    name: "Balloon",
    prize: "Rs. 32000/-",
    id: 32,
  },
  {
    img: "/productImgs/Balloons/balloon2.jpg",
    category: "Balloons",
    name: "Balloon",
    prize: "Rs. 32000/-",
    id: 33,
  },
  {
    img: "/productImgs/Balloons/balloon3.jpg",
    category: "Balloons",
    name: "Balloon",
    prize: "Rs. 32000/-",
    id: 34,
  },
  {
    img: "/productImgs/Balloons/balloon4.jpg",
    category: "Balloons",
    name: "Balloon",
    prize: "Rs. 32000/-",
    id: 35,
  },
  {
    img: "/productImgs/Balloons/balloon5.jpg",
    category: "Balloons",
    name: "Balloon",
    prize: "Rs. 32000/-",
    id: 36,
  },
  {
    img: "/productImgs/Balloons/balloon6.jpg",
    category: "Balloons",
    name: "Balloon",
    prize: "Rs. 32000/-",
    id: 37,
  },
  {
    img: "/productImgs/Balloons/balloon7.jpg",
    category: "Balloons",
    name: "Balloon",
    prize: "Rs. 32000/-",
    id: 38,
  },
  {
    img: "/productImgs/Balloons/balloon8.jpg",
    category: "Balloons",
    name: "Balloon",
    prize: "Rs. 32000/-",
    id: 39,
  },
  {
    img: "/productImgs/Inflatables/Inflatables1.jpg",
    category: "Inflatables",
    name: "Inflatables",
    prize: "Rs. 36000/-",
    id: 40,
  },
  {
    img: "/productImgs/Arches/Arche6.jpg",
    category: "Archies",
    name: "Arches",
    prize: "Rs. 15000/-",
    id: 41,
  },
  {
    img: "/productImgs/Arches/Arche7.jpg",
    category: "Archies",
    name: "Arches",
    prize: "Rs. 15000/-",
    id: 42,
  },
  {
    img: "/productImgs/Costumes/Costumes9.jpg",
    category: "Costumes",
    name: "Costumes",
    prize: "Rs. 25000/-",
    id: 43,
  },
  {
    img: "/productImgs/Balloons/balloon9.jpg",
    category: "Balloons",
    name: "Balloon",
    prize: "Rs. 32000/-",
    id: 44,
  },
  {
    img: "/productImgs/Balloons/balloon10.jpg",
    category: "Balloons",
    name: "Balloon",
    prize: "Rs. 32000/-",
    id: 45,
  },
  {
    img: "/productImgs/Balloons/balloon11.jpg",
    category: "Balloons",
    name: "Balloon",
    prize: "Rs. 32000/-",
    id: 46,
  },
  {
    img: "/productImgs/Balloons/balloon12.jpg",
    category: "Balloons",
    name: "Balloon",
    prize: "Rs. 32000/-",
    id: 47,
  },
  {
    img: "/productImgs/Balloons/balloon13.jpg",
    category: "Balloons",
    name: "Balloon",
    prize: "Rs. 32000/-",
    id: 48,
  },
  {
    img: "/productImgs/Inflatables/Inflatables2.jpg",
    category: "Inflatables",
    name: "Inflatables",
    prize: "Rs. 36000/-",
    id: 49,
  },
  {
    img: "/productImgs/Inflatables/Inflatables3.jpg",
    category: "Inflatables",
    name: "Inflatables",
    prize: "Rs. 36000/-",
    id: 50,
  },
  {
    img: "/productImgs/Inflatables/Inflatables4.jpg",
    category: "Inflatables",
    name: "Inflatables",
    prize: "Rs. 36000/-",
    id: 51,
  },
  {
    img: "/productImgs/Inflatables/Inflatables5.jpg",
    category: "Inflatables",
    name: "Inflatables",
    prize: "Rs. 36000/-",
    id: 52,
  },
  {
    img: "/productImgs/Inflatables/Inflatables6.jpg",
    category: "Inflatables",
    name: "Inflatables",
    prize: "Rs. 36000/-",
    id: 53,
  },
  {
    img: "/productImgs/Inflatables/Inflatables7.jpg",
    category: "Inflatables",
    name: "Inflatables",
    prize: "Rs. 36000/-",
    id: 54,
  },
  {
    img: "/productImgs/Inflatables/Inflatables8.jpg",
    category: "Inflatables",
    name: "Inflatables",
    prize: "Rs. 36000/-",
    id: 55,
  },
  {
    img: "/productImgs/Inflatables/Inflatables9.jpg",
    category: "Inflatables",
    name: "Inflatables",
    prize: "Rs. 36000/-",
    id: 56,
  },
  {
    img: "/productImgs/Inflatables/Inflatables10.jpg",
    category: "Inflatables",
    name: "Inflatables",
    prize: "Rs. 36000/-",
    id: 57,
  },
  {
    img: "/productImgs/Inflatables/Inflatables11.jpg",
    category: "Inflatables",
    name: "Inflatables",
    prize: "Rs. 36000/-",
    id: 58,
  },
  {
    img: "/productImgs/Inflatables/Inflatables12.jpg",
    category: "Inflatables",
    name: "Inflatables",
    prize: "Rs. 36000/-",
    id: 59,
  },
  {
    img: "/productImgs/Inflatables/Inflatables13.jpg",
    category: "Inflatables",
    name: "Inflatables",
    prize: "Rs. 36000/-",
    id: 60,
  },
  {
    img: "/productImgs/Inflatables/Inflatables14.jpg",
    category: "Inflatables",
    name: "Inflatables",
    prize: "Rs. 36000/-",
    id: 61,
  },
  {
    img: "/productImgs/Inflatables/Inflatables15.jpg",
    category: "Inflatables",
    name: "Inflatables",
    prize: "Rs. 36000/-",
    id: 62,
  },
  {
    img: "/productImgs/Inflatables/Inflatables16.jpg",
    category: "Inflatables",
    name: "Inflatables",
    prize: "Rs. 36000/-",
    id: 63,
  },
  {
    img: "/productImgs/Inflatables/Inflatables17.jpg",
    category: "Inflatables",
    name: "Inflatables",
    prize: "Rs. 36000/-",
    id: 64,
  },
  {
    img: "/productImgs/Inflatables/Inflatables18.jpg",
    category: "Inflatables",
    name: "Inflatables",
    prize: "Rs. 36000/-",
    id: 65,
  },
  {
    img: "/productImgs/Inflatables/Inflatables19.jpg",
    category: "Inflatables",
    name: "Inflatables",
    prize: "Rs. 36000/-",
    id: 66,
  },
  {
    img: "/productImgs/Inflatables/Inflatables20.jpg",
    category: "Inflatables",
    name: "Inflatables",
    prize: "Rs. 36000/-",
    id: 67,
  },
  {
    img: "/productImgs/Inflatables/Inflatables21.jpg",
    category: "Inflatables",
    name: "Inflatables",
    prize: "Rs. 36000/-",
    id: 68,
  },
  {
    img: "/productImgs/Inflatables/Inflatables22.jpg",
    category: "Inflatables",
    name: "Inflatables",
    prize: "Rs. 36000/-",
    id: 69,
  },
  {
    img: "/productImgs/Inflatables/Inflatables23.jpg",
    category: "Inflatables",
    name: "Inflatables",
    prize: "Rs. 36000/-",
    id: 70,
  },
  {
    img: "/productImgs/Inflatables/Inflatables24.jpg",
    category: "Inflatables",
    name: "Inflatables",
    prize: "Rs. 36000/-",
    id: 71,
  },
  {
    img: "/productImgs/Inflatables/Inflatables25.jpg",
    category: "Inflatables",
    name: "Inflatables",
    prize: "Rs. 36000/-",
    id: 72,
  },
  {
    img: "/productImgs/Inflatables/Inflatables26.jpg",
    category: "Inflatables",
    name: "Inflatables",
    prize: "Rs. 36000/-",
    id: 73,
  },
  {
    img: "/productImgs/Inflatables/Inflatables27.jpg",
    category: "Inflatables",
    name: "Inflatables",
    prize: "Rs. 36000/-",
    id: 74,
  },
  {
    img: "/productImgs/Inflatables/Inflatables28.jpg",
    category: "Inflatables",
    name: "Inflatables",
    prize: "Rs. 36000/-",
    id: 75,
  },
  {
    img: "/productImgs/Inflatables/Inflatables29.jpg",
    category: "Inflatables",
    name: "Inflatables",
    prize: "Rs. 36000/-",
    id: 76,
  },
  {
    img: "/productImgs/Inflatables/Inflatables30.jpg",
    category: "Inflatables",
    name: "Inflatables",
    prize: "Rs. 36000/-",
    id: 77,
  },
  {
    img: "/productImgs/Costumes/Costumes10.jpg",
    category: "Costumes",
    name: "Costumes",
    prize: "Rs. 36000/-",
    id: 78,
  },
  {
    img: "/productImgs/Costumes/Costumes11.jpg",
    category: "Costumes",
    name: "Costumes",
    prize: "Rs. 36000/-",
    id: 79,
  },
  {
    img: "/productImgs/Costumes/Costumes12.jpg",
    category: "Costumes",
    name: "Costumes",
    prize: "Rs. 36000/-",
    id: 80,
  },
  {
    img: "/productImgs/Costumes/Costumes13.jpg",
    category: "Costumes",
    name: "Costumes",
    prize: "Rs. 36000/-",
    id: 81,
  },
  {
    img: "/productImgs/Costumes/Costumes14.jpg",
    category: "Costumes",
    name: "Costumes",
    prize: "Rs. 36000/-",
    id: 82,
  },
  {
    img: "/productImgs/Costumes/Costumes15.jpg",
    category: "Costumes",
    name: "Costumes",
    prize: "Rs. 36000/-",
    id: 83,
  },
  {
    img: "/productImgs/Costumes/Costumes16.jpg",
    category: "Costumes",
    name: "Costumes",
    prize: "Rs. 36000/-",
    id: 84,
  },
  {
    img: "/productImgs/Costumes/Costumes17.jpg",
    category: "Costumes",
    name: "Costumes",
    prize: "Rs. 36000/-",
    id: 85,
  },
  {
    img: "/productImgs/Costumes/Costumes18.jpg",
    category: "Costumes",
    name: "Costumes",
    prize: "Rs. 36000/-",
    id: 86,
  },
];
